import { Table } from '@zillow/constellation';
import { VoidACHButton } from 'components/order/fees/edit/disbursements/Voiding/VoidACHButton';
import { VoidDisplay } from 'components/order/fees/edit/disbursements/Voiding/VoidDisplay';
import React from 'react';
import { prettyAccountType } from 'types/order/escrow/IAchAccountData';
import { IAchPushDisbursementData } from 'types/order/escrow/IAchPushDisbursementData';
import { getEscrowBankAccountLabel } from 'ui-toolkit/utilities/getEscrowBankAccountLabel';
import { currencyDisplay } from 'utilities/shared/currencyDisplay';
import { FeeInformation } from '../FeeInformationColumn';
import { DateFormat, getDateString } from 'ui-toolkit/utilities/getDateString';
import { useHasFeatureFlag } from 'selectors/useHasFeatureFlag';

export const AchPushDisbursementRow: React.FC<{ item: IAchPushDisbursementData }> = ({ item }) => {
  const isSpruceWithZillowEnabled = useHasFeatureFlag('pinecone.spruce-with-zillow-closing');
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');
  return (
    <Table.Row key={item.id}>
      <Table.Cell>
        <FeeInformation id={item.id} />
      </Table.Cell>
      <Table.Cell>{currencyDisplay(item.amountCents, true)}</Table.Cell>
      <Table.Cell>{item.category}</Table.Cell>
      <Table.Cell>{item.escrowBankAccount && getEscrowBankAccountLabel(item.escrowBankAccount, isSpruceWithZillowEnabled, isZillowClosingEnabled)}</Table.Cell>
      <Table.Cell>{item.escrowBankAccount?.accountNumber}</Table.Cell>
      <Table.Cell>{item.account?.name}</Table.Cell>
      <Table.Cell>{item.account?.accountType && prettyAccountType[item.account.accountType]}</Table.Cell>
      <Table.Cell>{item.account?.accountNumber}</Table.Cell>
      <Table.Cell>{item.account?.routingNumber}</Table.Cell>
      <Table.Cell>{item.wellsFargoTransactionNumber}</Table.Cell>
      <Table.Cell>{item.sentAt && getDateString(DateFormat.hugeDateTime, item.sentAt, true)}</Table.Cell>
      <Table.Cell>{item.disbursedAt && getDateString(DateFormat.hugeDate, item.disbursedAt)}</Table.Cell>
      <Table.Cell>{item.confirmedAt && getDateString(DateFormat.hugeDateTime, item.confirmedAt, true)}</Table.Cell>
      <Table.Cell>
        <VoidDisplay item={item} prettyVoidReason={item.voidReason} />
        <VoidACHButton achDisbursement={item} />
      </Table.Cell>
    </Table.Row>
  );
};
